import { createContext } from 'react';
import type { ReactNode } from 'react';
import { useSettingsState } from './useSettings';
import type { ISettingsContext } from './types';

export const SettingsContext = createContext<ISettingsContext>({
    websiteSettings: null,
    trackingSettings: null,
    announcementSettings: null,
    whatsappSettings: null,
    loading: true,
});

export const SettingsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { websiteSettings, trackingSettings, announcementSettings, whatsappSettings, loading } = useSettingsState();

    return (
        <SettingsContext.Provider value={{ websiteSettings, trackingSettings: trackingSettings as any, announcementSettings, whatsappSettings, loading }}>
            {children}
        </SettingsContext.Provider>
    );
};
